import React, { PropTypes } from 'react';
import Input from '../../Input';
import SimpleDialog from '../../SimpleDialog';
import FlatButton from 'material-ui/FlatButton';
import { FormattedMessage } from 'react-intl';

class UrlInputDialog extends React.Component {
  static propTypes = {
    handleDelete: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    fields: PropTypes.shape({
      url: PropTypes.object.isRequired
    }).isRequired,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    containsUrl: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired
  };

  render() {
    let {
      containsUrl,
      handleSubmit,
      handleDelete,
      open,
      onClose,
      fields: {
        url
      }
    } = this.props;

    let additionalActions = [
      <FlatButton
        label={<FormattedMessage id="dialog.delete" defaultMessage="Delete"/>}
        disabled={!containsUrl}
        primary={true}
        onClick={handleDelete}
      />
    ];

    let dialogOptions = {
      additionalActions,
      open,
      onClose,
      onSubmit: () => handleSubmit(this.props.onSubmit)
    };

    return (
      <SimpleDialog
        title="Url dialog"
        {...dialogOptions}>
        <Input label="Link" {...url}/>
      </SimpleDialog>
    );
  }
}

UrlInputDialog.defaultProps = {
  open: false
};

export default UrlInputDialog;




// WEBPACK FOOTER //
// ./src/components/form/RichEditor/UrlInputDialog/UrlInputDialog.jsx